const steps = [
  {
    icon: "ri-layout-grid-line",
    title: "第一步 · 判断稿件类型",
    desc: "先想清楚手里是「短线索」还是「带证据的长文」。短线索适合微信、私信，长文与截图证据包适合邮箱或在线表单。",
  },
  {
    icon: "ri-folder-open-line",
    title: "第二步 · 备好材料与时间线",
    desc: "按时间顺序整理关键人物、事件经过，截图记得带清晰时间戳。材料越完整，编辑审稿越省力、被采纳概率越高。",
  },
  {
    icon: "ri-shield-check-line",
    title: "第三步 · 核对真实与边界",
    desc: "确认信息来源真实可核实，不夸大、不含未经当事人同意的隐私与攻击性内容。真实且有依据，是投稿的第一原则。",
  },
  {
    icon: "ri-send-plane-line",
    title: "第四步 · 选对通道提交",
    desc: "短线索走微信、长文走邮箱、材料齐全走在线链接。一次把关键信息给全，可显著缩短排队审阅时间。",
  },
  {
    icon: "ri-chat-follow-up-line",
    title: "第五步 · 留意回复与补充",
    desc: "提交后常规 24–72 小时内审阅。若编辑追问细节请及时回应，时效性强的稿件记得主动标注「紧急」。",
  },
];

export default function Flow() {
  return (
    <section id="flow" className="scroll-mt-24 bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
            <i className="ri-road-map-line" aria-hidden="true"></i>
            投稿流程
          </span>
          <h2 className="mt-4 text-2xl font-bold text-foreground-950 md:text-4xl">
            三步选对路，五步把料递到编辑手上
          </h2>
          <p className="mt-3 text-base leading-relaxed text-foreground-600">
            别一上来就狂发消息。照着下面的流程走，又快又稳，还少踩坑。
          </p>
        </div>

        <div className="relative mx-auto mt-14 max-w-3xl">
          <div className="absolute left-5 top-4 bottom-4 w-px bg-primary-200 md:left-1/2"></div>
          <div className="flex flex-col gap-8">
            {steps.map((s, i) => {
              const left = i % 2 === 0;
              return (
                <div
                  key={s.title}
                  className={`relative flex items-start gap-5 md:items-center md:gap-0 ${
                    left ? "md:flex-row" : "md:flex-row-reverse"
                  }`}
                >
                  <div
                    className={`flex-1 rounded-2xl border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-primary-200 md:max-w-[calc(50%-3rem)] ${
                      left ? "md:mr-auto" : "md:ml-auto"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50">
                        <i className={`${s.icon} text-base`} aria-hidden="true"></i>
                      </span>
                      <h3 className="text-base font-bold text-foreground-950 md:text-lg">{s.title}</h3>
                    </div>
                    <p className="mt-3 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
                  </div>

                  <span className="absolute left-5 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center rounded-full border-2 border-background-100 bg-primary-500 md:left-1/2 md:-translate-x-1/2">
                    <span className="h-1.5 w-1.5 rounded-full bg-background-50"></span>
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}